<script>
export default {
    name: "SchemeDetails",

    props: {

        showModal: Boolean,
        schemes: Array,
        insurance: Object,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Insurance Scheme Details</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <table class="table">
                <thead class="bg-blue-500 text-sm text-white">
                    <tr class="w-full flex">
                        <th class="w-1/2 p-tiny">Scheme</th>
                        <th class="flex-1 p-tiny">Limit</th>
                        <th class="flex-1 p-tiny">Custom Limit</th>
                        <th class="flex-1 p-tiny">Active</th>
                    </tr>
                </thead>
                <tbody class="flex flex-col items-center overflow-auto text-xs">
                    <tr class="w-full flex" v-for="(scheme,idx) in schemes" :key="idx">
                        <td class="p-tiny w-1/2">{{ scheme.schemeName }}</td>
                        <td class="p-tiny flex-1">{{ scheme.limit }}</td>
                        <td class="p-tiny flex-1">{{ scheme.customizeLimit }}</td>
                        <td class="p-tiny flex-1">{{ scheme.active ? `Active` : `Inactive` }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Cancel</button>
      </template>
    </tail-modal>
</template>
